import React, { Component } from 'react';
import { base,  } from '../../../../config/constants.js'
import { Card, Icon, Image, Button, Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import WhatsappClientRejected from './WhatsappClientRejected';
import WhatsappDepRequest from './WhatsappDepRequest'
import WhatsappGetUsersPendingOrders from './WhatsappGetUsersPendingOrders'
import WhatsappConfirmDeposit from './WhatsappConfirmDeposit'
import { ResendMessage } from './ResendMessage';


class ChatBubble extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    removePlusSign = (phone) => {
        console.log("rpx1 +++++ removePlusSign ++ phone:" + phone);

        let newPhone = phone.toString();
        console.log("rpx2 newPhone to string:" + newPhone)

        newPhone = newPhone.replace("+", '')
        console.log("rpx3 after replace:" + newPhone)
        return newPhone;
    }

    getSenderNumber = () => {
        if (this.props.message.from && this.props.message.to && this.props.message.from == "+256702052564") {
            return this.removePlusSign(this.props.message.to)
        } else {
            return this.removePlusSign(this.props.message.from)
        }
    }

    deleteMessage = () => {
        console.log("+++++++ deleteMessage ++++++")

        base
            .remove('whatsapp/' + this.getSenderNumber() + '/messages/' + this.props.message.key)
            .then(() => {
                console.log("whatx1 message deleted:" + this.props.message.key)
                alert(" message deleted:" + this.props.message.key)
            })
            .catch(error => {
                //handle error
            });
    }

    render() {
        // const chat = this.props.message.from = "+256702052564"
        //     ? <Message
        //         icon='arrow alternate circle right'
        //         header={this.props.message.sentText}
        //         content={this.props.message.timeSent}
        //     />
        //     : <Message
        //         icon='arrow alternate circle left'
        //         header={this.props.message.sentText}
        //         content={this.props.message.timeSent}
        //     />

        const ImagePart = (props) => props.message.imageUrl
            ? <Image src={props.message.imageUrl} wrapped ui={false} />
            : ''

        // <Link to={props.message.imageUrl}>Listen</Link>
        const AudioPart = (props) => props.message.type == 'audio'
            ? <div>
                <Header as='h3'>
                    <Icon name='headphones' />
                    <Header.Content>
                        Audio File
                    <Header.Subheader><a href={props.message.imageUrl} target="_blank">Download</a></Header.Subheader>
                    </Header.Content>
                </Header>
            </div>
            : ''

        const VideoPart = (props) => props.message.type == 'video'
            ? <div>
                <Header as='h3'>
                    <Icon name='video' />
                    <Header.Content>
                        Video File
                    <Header.Subheader><a href={props.message.imageUrl} target="_blank">Download</a></Header.Subheader>
                    </Header.Content>
                </Header>
            </div>
            : ''

        const FilePart = (props) => props.message.type == 'file'
            ? <div>
                <Header as='h3'>
                    <Icon name='file alternate' />
                    <Header.Content>
                        File / Doc
                    <Header.Subheader><a href={props.message.imageUrl} target="_blank">Download</a></Header.Subheader>
                    </Header.Content>
                </Header>
            </div>
            : ''


        const FromPart = (props) => props.message.from == "+256702052564"
            ? <Card.Description>
                <Button color='blue' size='small'>Printboda</Button>
            </Card.Description>
            : <Card.Description>
                <Button color='red' size='small'>{this.props.message.from} </Button>
            </Card.Description>

        const searchNowOpenChat = this.props.searchNow
            ? <Button color='purple' size='small'><Link to={'/dashboard/singleChat/' + this.removePlusSign(this.props.message.from)} target="_blank">OPEN CHAT</Link> </Button>
            : ''


        const statusUpdates = this.props.algoliaUser && this.props.algoliaUser.whatsapp_reply && !this.props.searchNow
            ? <div>
                <WhatsappClientRejected phone={this.props.phone} />
                <WhatsappDepRequest phone={this.props.phone} />

                {/* IVAN_FIX */}
                <WhatsappConfirmDeposit phone={this.props.phone} order_num={this.props.message.order_num} />
                <WhatsappGetUsersPendingOrders phone={this.props.phone} messageId={this.props.message.key} message={this.props.message} />
            </div>
            : ''

        const ErrorPart = (props) => props.message.error_description && props.message.error_description != 'none'
            ?
            <div>
                <Card.Content extra>
                    <Icon name='times circle' color='red' size='big' />
                    {this.props.message.error_description}
                </Card.Content>
                <Card.Content extra>
                    <ResendMessage user={this.props.user} message={this.props.message} />
                </Card.Content>
                <br />
                <Card.Content extra>
                    Send Count:# {this.props.message.sendCount}
                </Card.Content>
            </div>

            : ''

        const viewFirebaseOrderUI = this.props.algoliaUser && this.props.algoliaUser.perms && this.props.algoliaUser.perms.includes("viewFirebaseOrder")
            ? <p>
                <div>
                    <a href={'https://console.firebase.google.com/u/0/project/printb-3daaa/database/printb-3daaa/data/~2Fwhatsapp~2F' + this.getSenderNumber(this.props.message) + '~2Fmessages~2F' + this.props.message.key} target="_blank">FIREBASE</a>
                    <br />
                    <Link to={'/dashboard/viewMessageLogs/live/' + this.props.message.key} target="_blank">MSG LOGS - LIVE</Link>
                    <br />
                    <Link to={'/dashboard/viewMessageLogs/local/' + this.props.message.key} target="_blank">MSG LOGS - local</Link>
                    <br/>
                    <Button color='red' onClick={this.deleteMessage}>DELETE MESSAGE</Button>
                </div>
            </p>
            : ''

        return (
            <div>
                <Card color='red'>
                    <ImagePart message={this.props.message} />
                    <AudioPart message={this.props.message} />
                    <VideoPart message={this.props.message} />
                    <FilePart message={this.props.message} />
                    <Card.Content>
                        <Card.Header>{this.props.message.sentText}</Card.Header>
                        <Card.Meta>{this.props.message.timeSent}</Card.Meta>
                        <FromPart message={this.props.message} />
                        {searchNowOpenChat}
                    </Card.Content>
                    <Card.Content extra>
                        <Icon name='user' />
                        {this.props.message.status}
                    </Card.Content>
                    <Card.Content extra>
                        <Icon name='hashtag' />
                        <Link to={'/dashboard/singleOrderView/' + this.props.message.order_num} target="_blank">{this.props.message.order_num}</Link>
                    </Card.Content>
                    <ErrorPart message={this.props.message} />
                    <Card.Content extra>
                        {this.props.message.key}
                    </Card.Content>
                    {statusUpdates}
                    {/* <WhatsappClientRejected phone={this.props.phone} />
                    <WhatsappDepRequest phone={this.props.phone} /> */}
                    <Card.Content extra>
                        {viewFirebaseOrderUI}
                    </Card.Content>
                </Card>
                <br />
            </div>
        );
    }
}


export default ChatBubble;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/ChatBubble.js